








import { defineComponent } from '@vue/composition-api';

/**
 * 高度渐变动画容器
 */
export default defineComponent({
  name: 'HeightAnimeContainer',
  setup() {
    return {
      leave(el: HTMLDivElement, done) {
        setTimeout(() => {
          done();
        }, 500);
      },
      beforeLeave(el: HTMLDivElement) {
        el.style.height = '0px';
        el.style.marginBottom = '0px';
      },
      enter(el: HTMLDivElement) {
        const containerEl = el.children[0];
        const { height } = getComputedStyle(containerEl);
        el.style.height = height;
      },
      afterEnter(el: HTMLDivElement) {
        el.style.height = '0px';
      },
    };
  },
});
